// extracted by mini-css-extract-plugin
export default {"wrapper":"VehicleSelector_wrapper__CbYcP","select":"VehicleSelector_select__6pExu"};